import reports from './actions.js';
import ui from '../ui/actions.js';
import * as s from './selectors.js';

import { push } from 'react-router-redux';


const container = '#report-container';


// for testing in isolation
const main = {
    _waitForVisualize,
    _connectToReports,
    _render,
};


function _waitForVisualize() {
    return new Promise((resolve, reject) => {

        const maxWaitInterval = 8;
        const initialWaitTimout = 200;

        const wait = (tries = 0, timeout = initialWaitTimout) => {
            if (typeof window.visualize !== 'function') {
                timeout *= tries + 1;

                return (tries >= maxWaitInterval)
                    ? reject({ message: 'connection failed, wait for visualize expired' })
                    : setTimeout(wait, timeout, tries + 1);
            }
            return resolve(window.visualize);
        };

        return wait();
    });
}


function _connectToReports() {
    return dispatch => new Promise((resolve, reject) => {

        dispatch(reports.connecting.on());

        const errorHandler = (error) => {
            dispatch(reports.session.clear());
            dispatch(reports.report.clear());
            dispatch(reports.connecting.off());
            dispatch(ui.flash.error({ header: 'Jaspersoft', content: error.message }));
            reject(error);
        };

        main._waitForVisualize()
            .then((visualize) => {
                visualize(
                    {
                        auth: {
                            name: 'collabReports',
                            password: 'collabReports',
                        },
                        server: process.env.JASPER_SERVER,
                    },
                    (v) => {
                        // session established, 'v' it's a client to JRS instance
                        dispatch(reports.session.set(v));
                        dispatch(reports.connecting.off());
                        resolve();
                    },
                    errorHandler,
                );
            })
            .catch(errorHandler);
    });
}


function _render(resource) {
    return (dispatch, getState) => new Promise((resolve, reject) => {

        dispatch(reports.loading.on());

        const session = s.getSession(getState());
        const report = session.report({
            container,
            resource,
            success: () => {
                dispatch(reports.loading.off());
                resolve();
            },
            error: (err) => {
                dispatch(reports.loading.off());
                reject(err);
            },
            linkOptions: {
                events: {
                    click: (e, link) => {
                        if (link.type === 'ReportExecution') {
                            dispatch(push(`/reports${link.resource}`));
                        }
                    },
                },
            },
        });

        dispatch(reports.report.set(report));
    });
}

export function renderReport(uri = 'dashboard') {
    return async (dispatch, getState) => {

        const resource = `/internal/${uri}`;
        const session = s.getSession(getState());

        if (!session) {
            await main._connectToReports()(dispatch);
        }

        try {
            await main._render(resource)(dispatch, getState);

        } catch (error) {
            if (error.errorCode === 'authentication.error') {
                // Session expired, time to reconnect
                dispatch(reports.session.clear());
                dispatch(reports.report.clear());

                return renderReport(uri)(dispatch, getState);
            }
            dispatch(ui.flash.error({ header: 'Jaspersoft', content: error.message }));
        }
    };
}


export function exportReport(outputFormat) {
    return (dispatch, getState) => {
        const report = s.getReport(getState());

        dispatch(reports.exporting.on());

        report.export(
            {
                outputFormat,
            },
            (link) => {
                dispatch(reports.exporting.off());
                const url = link.href ? link.href : link;
                window.location.assign(url);
            },
            (error) => {
                dispatch(reports.exporting.off());
                dispatch(ui.flash.error({ header: 'Jaspersoft', content: error.message }));
            },
        );
    };
}

// for testing in isolation
export default main;
